import { TextFieldProps } from '../TextField.types';

export const getIsInputDisabled = (
  props: Pick<TextFieldProps, 'disabled' | 'isDisabled' | 'isFakeDisabled'>,
) => {
  return props.disabled || props.isDisabled || props.isFakeDisabled;
};

export const cleanInputOnBlur = (value: string) =>
  value
    .replace(/[-/*]+$/, '')
    .replace(/^[-/*]+/, '')
    .replace(/\(\(/g, '(')
    .replace(/\)\)/g, ')')
    .trim();
